import { Link } from 'react-router-dom';

import type { PromesaPago, ReporteCxc, TramoAntiguedad } from '@leadsphere/types';

import { fmtFecha, fmtMXN } from '../../lib/moneda.js';

const NOMBRE_TRAMO: Record<TramoAntiguedad, string> = {
  al_corriente: 'Al corriente', '1_30': '1–30 días', '31_60': '31–60 días', '61_90': '61–90 días', mas_90: '+90 días',
};

function ListaPromesas({ titulo, promesas }: { titulo: string; promesas: PromesaPago[] }) {
  return (
    <div className="reportes-card">
      <div className="reportes-card-titulo">{titulo}</div>
      {promesas.length === 0 ? (
        <div className="reportes-vacio">Sin promesas.</div>
      ) : (
        <table className="main-table">
          <thead><tr><th>Fecha</th><th>Cliente</th><th>Periodo</th><th>Monto</th></tr></thead>
          <tbody>
            {promesas.map(p => (
              <tr key={p.entrada_id}>
                <td>{fmtFecha(p.promesa_pago)}</td>
                <td>{p.cliente}</td>
                <td>{p.mes} {p.anio}</td>
                <td>{fmtMXN(p.monto)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export function BloqueCobranza({ c }: { c: ReporteCxc['cobranza'] }) {
  return (
    <>
      <div className="reportes-card">
        <div className="reportes-card-titulo">Antigüedad de lo por cobrar</div>
        <div className="reportes-nota">
          {c.criterio.con_fecha_factura} entradas con fecha de factura + plazo; {c.criterio.por_mes_servicio} contadas desde el fin del mes de servicio.
        </div>
        <table className="main-table">
          <thead><tr><th>Tramo</th><th>Monto</th><th>Entradas</th><th>Acción</th></tr></thead>
          <tbody>
            {c.antiguedad.map(t => (
              <tr key={t.tramo}>
                <td>{NOMBRE_TRAMO[t.tramo]}</td>
                <td>{fmtMXN(t.monto)}</td>
                <td>{t.entradas}</td>
                <td>{t.accion ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="reportes-card">
        <div className="reportes-card-titulo">A quién cobrar</div>
        {c.a_quien_cobrar.length === 0 ? (
          <div className="reportes-vacio">No hay saldo pendiente.</div>
        ) : (
          <div className="table-scroll">
            <table className="main-table">
              <thead>
                <tr><th>Cliente</th><th>Por cobrar</th><th>Entradas</th><th>Días (más antigua)</th><th>Acción</th><th>Promesa</th><th>Último comentario</th></tr>
              </thead>
              <tbody>
                {c.a_quien_cobrar.map(f => (
                  <tr key={f.cliente_id}>
                    <td><Link to={`/cxc?cliente=${f.cliente_id}`}>{f.cliente}</Link></td>
                    <td>{fmtMXN(f.por_cobrar)}</td>
                    <td>{f.entradas}</td>
                    <td>{f.dias_mas_antigua} ({NOMBRE_TRAMO[f.tramo]})</td>
                    <td>{f.accion ?? '—'}</td>
                    <td>{f.promesa_proxima ? fmtFecha(f.promesa_proxima) : '—'}</td>
                    <td>{f.ultimo_comentario ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="reportes-grid-2">
        <ListaPromesas titulo="Promesas de pago: próximos 30 días" promesas={c.promesas.proximas} />
        <ListaPromesas titulo="Promesas de pago vencidas" promesas={c.promesas.vencidas} />
      </div>
    </>
  );
}
